export default "__VITE_ASSET__cB5AelT5__"